import React from 'react';
import './NoticePopup.css';
import { createPortal } from 'react-dom';
import { useLanguage } from '../context/LanguageContext.js';

// 👉 importe quelques petites icônes/images
import ContactsIcon from '../images/symbole-contacts.png';
import MenuIcon from '../images/glace.png';
import ListIcon from '../images/flute.png';

const NoticePopup = ({ onClose, headerHeight = 0 }) => {
  const { t } = useLanguage();

  return createPortal(
    <div className="notice-overlay" onClick={onClose}>
      <div 
      className="notice-popup" 
      onClick={(e) => e.stopPropagation()}
      style={{ marginTop: `${headerHeight + 24}px` }}
      >
        <button className="popup-close-button" onClick={onClose}>×</button>
        <h2>{t('Welcome')}</h2>
        <ul className="notice-list">
          <li>
            <img src={ContactsIcon} alt="Contacts" className="notice-icon-img" />
            {t('ImportYourContactsToSendTheSurvey')}
          </li>
          <li>
            <img src={MenuIcon} alt="Menus" className="notice-icon-img" />
            {t('CreateYourMenus')}
          </li>
          <li>
            <img src={ListIcon} alt="Liste" className="notice-icon-img-flute" />
            {t('TheListIsreadyToBeSHared')}
          </li>
        </ul>
      </div>
    </div>,
    document.body
  );
};

export default NoticePopup;
